// @flow

import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";
import { fragments as transfersStandardOrderStatusFragments } from "../../application/apps/TransferPrintingApp/components/TransfersStandardOrderStatus/graph";

const markOrderAsTransfersStandardManualPrintingStarted: any = graphql(
  gql`
    mutation($orderId: ID!) {
      markOrderAsTransfersStandardManualPrintingStarted(orderId: $orderId) {
        errors {
          orderId
        }
        updatedOrder {
          ...TransfersStandardOrderStatus_order
        }
        succeeded
      }
    }
    ${transfersStandardOrderStatusFragments.order}
  `,
  {
    name: "markOrderAsTransfersStandardManualPrintingStarted"
  }
);

export default markOrderAsTransfersStandardManualPrintingStarted;
